export default '/static/frontend/ReachDigital/12gobiking/dist/assets/transferencia-bancaria-e0fa5d91.jpg'